import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWindows = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "icon-wrapper",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M11.375 1.96875H7.21875C7.09844 1.96875 7 2.06719 7 2.1875V6.34375C7 6.46406 7.09844 6.5625 7.21875 6.5625H11.375C11.4953 6.5625 11.5938 6.46406 11.5938 6.34375V2.1875C11.5938 2.06719 11.4953 1.96875 11.375 1.96875ZM11.375 7.4375H7.21875C7.09844 7.4375 7 7.53594 7 7.65625V11.8125C7 11.9328 7.09844 12.0312 7.21875 12.0312H11.375C11.4953 12.0312 11.5938 11.9328 11.5938 11.8125V7.65625C11.5938 7.53594 11.4953 7.4375 11.375 7.4375ZM5.90625 1.96875H1.75C1.62969 1.96875 1.53125 2.06719 1.53125 2.1875V6.34375C1.53125 6.46406 1.62969 6.5625 1.75 6.5625H5.90625C6.02656 6.5625 6.125 6.46406 6.125 6.34375V2.1875C6.125 2.06719 6.02656 1.96875 5.90625 1.96875ZM5.90625 7.4375H1.75C1.62969 7.4375 1.53125 7.53594 1.53125 7.65625V11.8125C1.53125 11.9328 1.62969 12.0312 1.75 12.0312H5.90625C6.02656 12.0312 6.125 11.9328 6.125 11.8125V7.65625C6.125 7.53594 6.02656 7.4375 5.90625 7.4375Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgWindows);
export { ForwardRef as ReactComponent };
